/*!
 * LENZ Access v0.3.0 (MVP)
 * Widget de accesibilidad autocontenido para lenz.pe (Shopify, theme Impact).
 * Inspirado en el modulo EqualWeb usado por bhphotovideo.com, con mejoras:
 *   - 0 dependencias, 0 requests externos, 0 tracking (privacidad + performance)
 *   - Lector de texto (TTS) nativo via Web Speech API, con seleccion de voz
 *     para Peru (es-PE > es-US/es-419/es-MX > es-ES > es) y lectura por oraciones
 *   - Idiomas: espanol (Peru), runasimi/quechua chanka y ingles
 *   - Persistencia local, auto-deteccion de prefers-reduced-motion
 *   - El propio widget cumple WCAG: dialogo ARIA, focus trap, 100% teclado, ESC
 * Instalacion Shopify: subir como asset y cargar con <script defer> antes de </body>.
 * Config opcional: window.LenzA11yConfig = { lang, accent, statementEmail, position }
 */
(function () {
  'use strict';
  if (window.__lenzA11yLoaded) return;
  window.__lenzA11yLoaded = true;

  function mapLang(l) {
    l = String(l || '').slice(0, 2).toLowerCase();
    return (l === 'en' || l === 'qu') ? l : 'es';
  }

  var CFG = Object.assign({
    lang: mapLang(document.documentElement.lang || 'es'),
    accent: '#0B5394',
    accentDark: '#083D6E',
    statementEmail: 'ventas@lenz.pe',
    siteName: location.hostname.replace('www.', '') || 'este sitio',
    position: 'right', // right | left
    zIndex: 2147483000,
    // standby: true = sin boton flotante; el panel se abre solo via
    // Alt+0, window.LenzA11y.open(), un enlace a #accesibilidad
    // (ej. item "Accesibilidad" en el menu del footer) o [data-lenz-a11y]
    standby: false
  }, window.LenzA11yConfig || {});
  CFG.lang = mapLang(CFG.lang);

  var LS_KEY = 'lenz-a11y:v1';
  var ROOT_ID = 'lenz-a11y-root';
  var NOTROOT = ':not(#' + ROOT_ID + '):not(#' + ROOT_ID + ' *)';

  /* ------------------------------------------------------------------ i18n */
  var I18N = {
    es: {
      openBtn: 'Abrir menú de accesibilidad (Alt+0)',
      title: 'Accesibilidad',
      close: 'Cerrar',
      profiles: 'Perfiles de accesibilidad',
      profilesHint: 'Un toque activa un conjunto de ajustes',
      content: 'Ajustes de contenido',
      color: 'Ajustes de color',
      nav: 'Orientación y navegación',
      tools: 'Herramientas',
      reset: 'Restablecer todo',
      statement: 'Declaración de accesibilidad',
      hide: 'Ocultar widget',
      moveSide: 'Mover panel al otro lado',
      language: 'Cambiar idioma / Change language',
      active: 'activado',
      level: 'Nivel',
      off: 'Apagado',
      // profiles
      p_motor: 'Motriz', p_motor_d: 'Navegación por teclado y foco visible',
      p_lowvision: 'Baja visión', p_lowvision_d: 'Texto grande, enlaces resaltados',
      p_colorblind: 'Daltonismo', p_colorblind_d: 'Más saturación y enlaces resaltados',
      p_seizure: 'Epilepsia', p_seizure_d: 'Sin animaciones, colores suaves',
      p_adhd: 'TDAH', p_adhd_d: 'Máscara y guía de lectura',
      p_dyslexia: 'Dislexia', p_dyslexia_d: 'Fuente amigable y espaciado',
      p_senior: 'Adulto mayor', p_senior_d: 'Todo más grande y claro',
      // features
      f_fontSize: 'Tamaño de texto',
      f_readableFont: 'Fuente legible',
      f_dyslexiaFont: 'Fuente dislexia',
      f_letterSpacing: 'Espaciado de letras',
      f_lineHeight: 'Altura de línea',
      f_highlightLinks: 'Resaltar enlaces',
      f_highlightHeadings: 'Resaltar títulos',
      f_darkContrast: 'Contraste oscuro',
      f_brightContrast: 'Contraste claro',
      f_monochrome: 'Monocromo',
      f_lowSat: 'Baja saturación',
      f_highSat: 'Alta saturación',
      f_bigCursor: 'Cursor grande',
      f_readingGuide: 'Guía de lectura',
      f_readingMask: 'Máscara de lectura',
      f_stopAnimations: 'Parar animaciones',
      f_hideImages: 'Ocultar imágenes',
      f_focusMode: 'Foco visible (teclado)',
      f_pageZoom: 'Zoom de página',
      f_tts: 'Lector de texto',
      f_ttsHint: 'Activa y haz clic en cualquier texto para escucharlo',
      f_textMagnifier: 'Lupa de texto',
      f_pageStructure: 'Estructura de página',
      // structure dialog
      s_title: 'Estructura de página',
      s_headings: 'Encabezados',
      s_links: 'Enlaces',
      s_landmarks: 'Regiones',
      s_empty: 'No se encontraron elementos',
      // statement
      st_title: 'Declaración de accesibilidad',
      st_body: 'Nos esforzamos por que {site} sea usable por la mayor cantidad de personas posible, con WCAG 2.2 AA como referencia. Este panel (LENZ Access) permite ajustar colores, tipografía, navegación y lectura en voz alta, procesando todo en tu navegador: no se envían datos a ningún servidor. Si encuentras una barrera de accesibilidad, escríbenos a {email} y la corregiremos.',
      ttsUnsupported: 'Tu navegador no soporta lectura en voz alta',
      autoReducedMotion: 'Animaciones desactivadas automáticamente (preferencia de tu sistema)'
    },
    en: {
      openBtn: 'Open accessibility menu (Alt+0)',
      title: 'Accessibility',
      close: 'Close',
      profiles: 'Accessibility profiles',
      profilesHint: 'One tap enables a bundle of adjustments',
      content: 'Content adjustments',
      color: 'Color adjustments',
      nav: 'Orientation & navigation',
      tools: 'Tools',
      reset: 'Reset all',
      statement: 'Accessibility statement',
      hide: 'Hide widget',
      moveSide: 'Move panel to the other side',
      language: 'Change language / Cambiar idioma',
      active: 'enabled',
      level: 'Level',
      off: 'Off',
      p_motor: 'Motor', p_motor_d: 'Keyboard navigation & visible focus',
      p_lowvision: 'Low vision', p_lowvision_d: 'Bigger text, highlighted links',
      p_colorblind: 'Color blind', p_colorblind_d: 'More saturation, highlighted links',
      p_seizure: 'Seizure safe', p_seizure_d: 'No animations, soft colors',
      p_adhd: 'ADHD', p_adhd_d: 'Reading mask & guide',
      p_dyslexia: 'Dyslexia', p_dyslexia_d: 'Friendly font & spacing',
      p_senior: 'Senior', p_senior_d: 'Everything bigger and clearer',
      f_fontSize: 'Font size',
      f_readableFont: 'Readable font',
      f_dyslexiaFont: 'Dyslexia font',
      f_letterSpacing: 'Letter spacing',
      f_lineHeight: 'Line height',
      f_highlightLinks: 'Highlight links',
      f_highlightHeadings: 'Highlight headings',
      f_darkContrast: 'Dark high-contrast',
      f_brightContrast: 'Bright high-contrast',
      f_monochrome: 'Monochrome',
      f_lowSat: 'Low saturation',
      f_highSat: 'High saturation',
      f_bigCursor: 'Big cursor',
      f_readingGuide: 'Reading guide',
      f_readingMask: 'Reading mask',
      f_stopAnimations: 'Stop animations',
      f_hideImages: 'Hide images',
      f_focusMode: 'Visible focus (keyboard)',
      f_pageZoom: 'Page zoom',
      f_tts: 'Text reader',
      f_ttsHint: 'Turn on, then click any text to hear it',
      f_textMagnifier: 'Text magnifier',
      f_pageStructure: 'Page structure',
      s_title: 'Page structure',
      s_headings: 'Headings',
      s_links: 'Links',
      s_landmarks: 'Landmarks',
      s_empty: 'Nothing found',
      st_title: 'Accessibility statement',
      st_body: 'We aim to make {site} usable by as many people as possible, using WCAG 2.2 AA as our reference. This panel (LENZ Access) adjusts colors, typography, navigation and read-aloud entirely in your browser: no data is sent to any server. If you hit an accessibility barrier, write to {email} and we will fix it.',
      ttsUnsupported: 'Your browser does not support speech synthesis',
      autoReducedMotion: 'Animations disabled automatically (your system preference)'
    },
    /* Runasimi (quechua chanka, ortografia normalizada MINEDU). Traduccion
       funcional con prestamos del castellano de uso corriente (letra, link,
       pagina, teclado); pendiente revision por hablante nativo. */
    qu: {
      openBtn: 'Yanapakuykuna kichay (Alt+0)',
      title: 'Yanapakuykuna',
      close: 'Wichqay',
      profiles: 'Sapa runapaq',
      profilesHint: 'Huk ñitiyllawan achka allichaykuna',
      content: 'Qillqa allichay',
      color: 'Llimpi allichay',
      nav: 'Puriy yanapay',
      tools: 'Llamkanakuna',
      reset: 'Llapanta kutichiy',
      statement: 'Yanapakuymanta willakuy',
      hide: 'Widget pakay',
      moveSide: 'Waq ladoman apay',
      language: 'Simita tikray / Cambiar idioma',
      active: 'hapichisqa',
      level: 'Nivel',
      off: 'Wañuchisqa',
      p_motor: 'Makipaq', p_motor_d: 'Tecladollawan puriy, foco rikunalla',
      p_lowvision: 'Pisi qawaq', p_lowvision_d: 'Hatun letra, linkkuna kancharisqa',
      p_colorblind: 'Llimpi mana riqsiq', p_colorblind_d: 'Aswan llimpi, linkkuna kancharisqa',
      p_seizure: 'Epilepsiapaq', p_seizure_d: 'Mana kuyuykuna, llampu llimpikuna',
      p_adhd: 'TDAH', p_adhd_d: 'Ñawinchay pakana, pusaq siqi',
      p_dyslexia: 'Dislexiapaq', p_dyslexia_d: 'Facil letra, karunchasqa qillqa',
      p_senior: 'Yuyaqkunapaq', p_senior_d: 'Llapan aswan hatun, aswan chuya',
      f_fontSize: 'Letra hatunyachiy',
      f_readableFont: 'Chuya letra',
      f_dyslexiaFont: 'Dislexia letra',
      f_letterSpacing: 'Letra karunchay',
      f_lineHeight: 'Siqi karunchay',
      f_highlightLinks: 'Link kanchariy',
      f_highlightHeadings: 'Titulo kanchariy',
      f_darkContrast: 'Tuta hina',
      f_brightContrast: 'Punchaw hina',
      f_monochrome: 'Yana-yuraq',
      f_lowSat: 'Pisi llimpi',
      f_highSat: 'Achka llimpi',
      f_bigCursor: 'Hatun cursor',
      f_readingGuide: 'Pusaq siqi',
      f_readingMask: 'Ñawinchay pakana',
      f_stopAnimations: 'Kuyuy sayachiy',
      f_hideImages: 'Foto pakay',
      f_focusMode: 'Teclado puriy',
      f_pageZoom: 'Pagina hatunyachiy',
      f_tts: 'Qillqa rimachiy',
      f_ttsHint: 'Hapichiy, hinaspa ima qillqatapas ñitiy uyarinapaq',
      f_textMagnifier: 'Qillqa lupa',
      f_pageStructure: 'Paginata puriy',
      s_title: 'Paginata puriy',
      s_headings: 'Titulukuna',
      s_links: 'Linkkuna',
      s_landmarks: 'Taqakuna',
      s_empty: 'Mana imapas tarikunchu',
      st_title: 'Yanapakuymanta willakuy',
      st_body: '{site} nisqaqa llapan runapaqmi kanan. Kay yanapakuyqa llimpikunata, letrata, ñawinchaytapas allichan; llapanmi kikin navegadorniykipi ruwakun, mana ima datoykipas waq serverman rinchu. Sasachakuyta tarispaqa {email} nisqaman qillqamuy, allichasaqkum.',
      ttsUnsupported: 'Kay navegadorqa manam rimachiyta atinchu',
      autoReducedMotion: 'Kuyuykuna wañuchisqa (sistemapa munayninman hina)'
    }
  };
  function t(key) {
    var dict = I18N[state.lang] || I18N.es;
    return dict[key] || I18N.es[key] || key;
  }

  /* ----------------------------------------------------------------- state */
  var DEFAULTS = {
    lang: CFG.lang,
    position: CFG.position,
    profile: null,
    features: {
      fontSize: 0,          // 0..4 -> 100/110/125/150/175 %
      readableFont: false,
      dyslexiaFont: false,
      letterSpacing: false,
      lineHeight: false,
      highlightLinks: false,
      highlightHeadings: false,
      darkContrast: false,
      brightContrast: false,
      monochrome: false,
      lowSat: false,
      highSat: false,
      bigCursor: false,
      readingGuide: false,
      readingMask: false,
      stopAnimations: false,
      hideImages: false,
      focusMode: false,
      pageZoom: 0,          // 0..3 -> 100/110/125/150 %
      tts: false,
      textMagnifier: false
    }
  };
  var FONT_STEPS = [1, 1.1, 1.25, 1.5, 1.75];
  var ZOOM_STEPS = [1, 1.1, 1.25, 1.5];

  var state = load();
  function load() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return JSON.parse(JSON.stringify(DEFAULTS));
      var saved = JSON.parse(raw);
      var s = JSON.parse(JSON.stringify(DEFAULTS));
      s.lang = saved.lang || s.lang;
      s.position = saved.position || s.position;
      s.profile = saved.profile || null;
      Object.keys(s.features).forEach(function (k) {
        if (saved.features && saved.features[k] !== undefined) s.features[k] = saved.features[k];
      });
      return s;
    } catch (e) { return JSON.parse(JSON.stringify(DEFAULTS)); }
  }
  function save() { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {} }

  /* ------------------------------------------------- profiles (presets) */
  var PROFILES = {
    motor:      { focusMode: true, bigCursor: true },
    lowvision:  { fontSize: 2, readableFont: true, highlightLinks: true, highlightHeadings: true, bigCursor: true },
    colorblind: { highSat: true, highlightLinks: true },
    seizure:    { stopAnimations: true, lowSat: true },
    adhd:       { readingMask: true, readingGuide: true, stopAnimations: true },
    dyslexia:   { dyslexiaFont: true, letterSpacing: true, lineHeight: true, readingGuide: true },
    senior:     { fontSize: 2, readableFont: true, highlightLinks: true, bigCursor: true, focusMode: true }
  };
  var PROFILE_ICONS = {
    motor: iconKeyboard(), lowvision: iconEyePlus(), colorblind: iconPalette(),
    seizure: iconShield(), adhd: iconTarget(), dyslexia: iconTypeDx(), senior: iconPerson()
  };

  /* -------------------------------------------------------------- helpers */
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------------------------------------------------- dynamic page CSS */
  var fxStyle = null; // effects applied to the page
  function syncEffects() {
    var f = state.features;
    var css = [];
    var filters = [];

    if (f.monochrome) filters.push('grayscale(1)');
    if (f.lowSat) filters.push('saturate(0.45)');
    if (f.highSat) filters.push('saturate(2.2)');
    if (filters.length) css.push('html{filter:' + filters.join(' ') + ' !important;}');

    if (f.darkContrast) {
      css.push(
        'html{background:#000 !important;}',
        'body' + NOTROOT + ',body ' + NOTROOT + '{background-color:#000 !important;background-image:none !important;color:#fff !important;border-color:#666 !important;box-shadow:none !important;text-shadow:none !important;}',
        'body a' + NOTROOT + '{color:#ffff00 !important;text-decoration:underline !important;}',
        'body h1' + NOTROOT + ',body h2' + NOTROOT + ',body h3' + NOTROOT + ',body h4' + NOTROOT + ',body h5' + NOTROOT + ',body h6' + NOTROOT + '{color:#40dfff !important;}',
        'body img' + NOTROOT + ',body video' + NOTROOT + ',body svg' + NOTROOT + ',body picture' + NOTROOT + ',body iframe' + NOTROOT + '{background-color:transparent !important;}'
      );
    }
    if (f.brightContrast) {
      css.push(
        'html{background:#fff !important;}',
        'body' + NOTROOT + ',body ' + NOTROOT + '{background-color:#fff !important;background-image:none !important;color:#000 !important;border-color:#333 !important;box-shadow:none !important;text-shadow:none !important;}',
        'body a' + NOTROOT + '{color:#0000e0 !important;text-decoration:underline !important;}',
        'body img' + NOTROOT + ',body video' + NOTROOT + ',body svg' + NOTROOT + ',body picture' + NOTROOT + ',body iframe' + NOTROOT + '{background-color:transparent !important;}'
      );
    }
    if (f.highlightLinks) {
      css.push('body a[href]' + NOTROOT + '{text-decoration:underline !important;background-color:#fff53d !important;color:#00119e !important;border-radius:2px;}');
    }
    if (f.highlightHeadings) {
      css.push('body h1' + NOTROOT + ',body h2' + NOTROOT + ',body h3' + NOTROOT + ',body h4' + NOTROOT + ',body h5' + NOTROOT + ',body h6' + NOTROOT +
        '{background-color:#ffe8a3 !important;color:#111 !important;box-shadow:inset 0 -3px 0 #b36b00 !important;}');
    }
    if (f.readableFont) {
      css.push('body ' + NOTROOT + '{font-family:Arial,Helvetica,"Segoe UI",sans-serif !important;}');
    }
    if (f.dyslexiaFont) {
      css.push('body ' + NOTROOT + '{font-family:"Comic Sans MS","Comic Sans",Verdana,Arial,sans-serif !important;}');
    }
    if (f.letterSpacing) {
      css.push('body ' + NOTROOT + '{letter-spacing:0.12em !important;word-spacing:0.16em !important;}');
    }
    if (f.lineHeight) {
      css.push('body p' + NOTROOT + ',body li' + NOTROOT + ',body dd' + NOTROOT + ',body dt' + NOTROOT + ',body blockquote' + NOTROOT + '{line-height:1.9 !important;}');
    }
    if (f.stopAnimations) {
      css.push('body *' + NOTROOT + ',body *' + NOTROOT + '::before,body *' + NOTROOT + '::after{animation:none !important;transition:none !important;scroll-behavior:auto !important;}');
      // coherencia: el propio widget tampoco anima cuando el usuario pide pararlas
      css.push('#' + ROOT_ID + ',#' + ROOT_ID + ' *{animation:none !important;transition:none !important;}');
    }
    if (f.hideImages) {
      css.push(
        'body img' + NOTROOT + ',body picture' + NOTROOT + ',body video' + NOTROOT + ',body figure' + NOTROOT + ',body iframe' + NOTROOT + ',body svg' + NOTROOT + '{visibility:hidden !important;}',
        'body *' + NOTROOT + '{background-image:none !important;}'
      );
    }
    if (f.focusMode) {
      css.push(
        'body *' + NOTROOT + ':focus{outline:4px solid #e4372b !important;outline-offset:3px !important;border-radius:2px;}',
        'body a' + NOTROOT + ':focus,body button' + NOTROOT + ':focus{background-color:#fff53d !important;color:#000 !important;}'
      );
    }
    if (f.bigCursor) {
      var cur = bigCursorData();
      css.push('body,body *' + NOTROOT + '{cursor:url("' + cur + '") 5 3, auto !important;}');
    }
    fxStyle.textContent = css.join('\n');

    // page zoom (property `zoom`: Chromium/WebKit/Firefox 126+)
    try { document.documentElement.style.zoom = ZOOM_STEPS[f.pageZoom] === 1 ? '' : ZOOM_STEPS[f.pageZoom]; } catch (e) {}

    applyFontSize();
    syncReadingHelpers();
    syncTts();
    syncTextMagnifier();
    if (f.stopAnimations) freezeMotion();
  }

  /* ------------------------------------------------------ font size walk */
  var FS_SELECTOR = 'p,li,a,span,h1,h2,h3,h4,h5,h6,td,th,dt,dd,label,button,figcaption,blockquote,small,strong,em,b,i,u,summary,time,cite,legend,input,textarea,select';
  var fsTouched = [];
  function applyFontSize() {
    var mult = FONT_STEPS[state.features.fontSize] || 1;
    // restore previous
    fsTouched.forEach(function (n) {
      if (n && n.style) {
        n.style.removeProperty('font-size');
        if (n.getAttribute('style') === '') n.removeAttribute('style');
      }
    });
    fsTouched = [];
    if (mult === 1) return;
    var root = document.getElementById(ROOT_ID);
    var nodes = document.body.querySelectorAll(FS_SELECTOR);
    var count = 0;
    for (var i = 0; i < nodes.length && count < 6000; i++) {
      var n = nodes[i];
      if (root && root.contains(n)) continue;
      var base = n.dataset.lenzFs;
      if (!base) {
        base = parseFloat(getComputedStyle(n).fontSize) || 16;
        n.dataset.lenzFs = base;
      }
      n.style.setProperty('font-size', (parseFloat(base) * mult).toFixed(2) + 'px', 'important');
      fsTouched.push(n);
      count++;
    }
  }

  /* ------------------------------------------- reading guide & mask */
  var guideEl = null, maskTop = null, maskBottom = null, helpersBound = false;
  function syncReadingHelpers() {
    var f = state.features;
    if (f.readingGuide && !guideEl) {
      guideEl = el('div', { 'class': 'lenz-a11y-guide', 'aria-hidden': 'true' });
      document.body.appendChild(guideEl);
    }
    if (!f.readingGuide && guideEl) { guideEl.remove(); guideEl = null; }
    if (f.readingMask && !maskTop) {
      maskTop = el('div', { 'class': 'lenz-a11y-mask', 'aria-hidden': 'true' });
      maskBottom = el('div', { 'class': 'lenz-a11y-mask', 'aria-hidden': 'true' });
      document.body.appendChild(maskTop); document.body.appendChild(maskBottom);
      positionMask(window.innerHeight / 2);
    }
    if (!f.readingMask && maskTop) { maskTop.remove(); maskBottom.remove(); maskTop = maskBottom = null; }
    if (!helpersBound) {
      helpersBound = true;
      document.addEventListener('mousemove', function (ev) {
        if (guideEl) {
          guideEl.style.top = (ev.clientY + 14) + 'px';
          guideEl.style.left = clamp(ev.clientX - 160, 4, window.innerWidth - 330) + 'px';
        }
        if (maskTop) positionMask(ev.clientY);
      }, { passive: true });
    }
  }
  function positionMask(y) {
    var half = 70;
    maskTop.style.cssText = 'top:0;height:' + clamp(y - half, 0, window.innerHeight) + 'px;';
    maskBottom.style.cssText = 'top:' + (y + half) + 'px;height:' + clamp(window.innerHeight - y - half, 0, window.innerHeight) + 'px;';
  }

  /* -------------------------------------------------- stop motion extras */
  function freezeMotion() {
    try { (document.getAnimations ? document.getAnimations() : []).forEach(function (a) { try { a.pause(); } catch (e) {} }); } catch (e) {}
    try { document.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} }); } catch (e) {}
  }

  /* --------------------------------------------------------------- TTS */
  var ttsBound = false, ttsHoverEl = null, voiceList = [];
  if ('speechSynthesis' in window) {
    voiceList = window.speechSynthesis.getVoices() || [];
    window.speechSynthesis.addEventListener && window.speechSynthesis.addEventListener('voiceschanged', function () {
      voiceList = window.speechSynthesis.getVoices() || [];
    });
  }
  // Realidad peruana: preferir voz es-PE; si no hay (lo usual), voz latina
  // (es-US/es-419/es-MX) antes que es-ES. Para runasimi no existen voces de
  // sintetizador: se lee con voz en espanol (la ortografia quechua es
  // foneticamente cercana, resultado inteligible).
  var VOICE_PREFS = {
    es: ['es-PE', 'es-US', 'es-419', 'es-MX', 'es-CO', 'es-AR', 'es-ES', 'es'],
    qu: ['qu-PE', 'qu', 'es-PE', 'es-US', 'es-419', 'es-MX', 'es-ES', 'es'],
    en: ['en-US', 'en-GB', 'en']
  };
  function pickVoice() {
    var prefs = VOICE_PREFS[state.lang] || VOICE_PREFS.es;
    for (var i = 0; i < prefs.length; i++) {
      var want = prefs[i].toLowerCase();
      var exact = voiceList.find(function (v) { return v.lang && v.lang.toLowerCase().replace('_', '-') === want; });
      if (exact) return exact;
      var pfx = voiceList.find(function (v) { return v.lang && v.lang.toLowerCase().replace('_', '-').indexOf(want + '-') === 0; });
      if (pfx) return pfx;
    }
    return null;
  }
  function splitSentences(text) {
    // trocear por oraciones (~<=200 chars) evita cortes del motor TTS en textos largos
    var parts = text.match(/[^.!?¡¿\n]+[.!?]*\s*/g) || [text];
    var chunks = [], buf = '';
    parts.forEach(function (p) {
      if ((buf + p).length > 200 && buf) { chunks.push(buf.trim()); buf = ''; }
      buf += p;
    });
    if (buf.trim()) chunks.push(buf.trim());
    return chunks.slice(0, 40);
  }
  function speak(text) {
    if (!('speechSynthesis' in window)) return;
    window.speechSynthesis.cancel();
    var voice = pickVoice();
    var fallbackLang = state.lang === 'en' ? 'en-US' : 'es-PE';
    splitSentences(text.slice(0, 5000)).forEach(function (chunk) {
      var u = new SpeechSynthesisUtterance(chunk);
      if (voice) { u.voice = voice; u.lang = voice.lang; }
      else u.lang = fallbackLang;
      u.rate = 0.95;
      window.speechSynthesis.speak(u);
    });
  }
  function ttsClick(ev) {
    if (!state.features.tts) return;
    var root = document.getElementById(ROOT_ID);
    if (root && root.contains(ev.target)) return;
    var target = ev.target.closest('p,li,h1,h2,h3,h4,h5,h6,a,button,td,th,label,figcaption,blockquote,span,div');
    if (!target) return;
    var text = (target.innerText || target.textContent || '').trim();
    if (!text) return;
    ev.preventDefault(); ev.stopPropagation();
    speak(text);
    flash(target);
  }
  function ttsOver(ev) {
    if (!state.features.tts) return;
    var root = document.getElementById(ROOT_ID);
    if (root && root.contains(ev.target)) return;
    var target = ev.target.closest('p,li,h1,h2,h3,h4,h5,h6,a,button,td,th,label,figcaption,blockquote');
    if (target === ttsHoverEl) return;
    if (ttsHoverEl) ttsHoverEl.classList.remove('lenz-a11y-tts-hover');
    ttsHoverEl = target;
    if (target) target.classList.add('lenz-a11y-tts-hover');
  }
  function syncTts() {
    if (state.features.tts && !ttsBound) {
      ttsBound = true;
      document.addEventListener('click', ttsClick, true);
      document.addEventListener('mouseover', ttsOver, true);
    }
    if (!state.features.tts) {
      if (ttsHoverEl) { ttsHoverEl.classList.remove('lenz-a11y-tts-hover'); ttsHoverEl = null; }
      if ('speechSynthesis' in window) window.speechSynthesis.cancel();
      document.documentElement.classList.toggle('lenz-a11y-ttsmode', false);
    } else {
      document.documentElement.classList.toggle('lenz-a11y-ttsmode', true);
    }
  }
  function flash(node) {
    node.classList.add('lenz-a11y-flash');
    setTimeout(function () { node.classList.remove('lenz-a11y-flash'); }, 1600);
  }

  /* ----------------------------------------------------- text magnifier */
  var magEl = null, magBound = false;
  function syncTextMagnifier() {
    if (state.features.textMagnifier && !magEl) {
      magEl = el('div', { 'class': 'lenz-a11y-magnifier', 'aria-hidden': 'true' });
      document.body.appendChild(magEl);
      if (!magBound) {
        magBound = true;
        document.addEventListener('mousemove', function (ev) {
          if (!magEl) return;
          var root = document.getElementById(ROOT_ID);
          if (root && root.contains(ev.target)) { magEl.style.display = 'none'; return; }
          var tgt = ev.target && ev.target.closest ? ev.target.closest('p,li,h1,h2,h3,h4,h5,h6,a,td,th,label,figcaption,blockquote,button,span') : null;
          var text = tgt ? (tgt.innerText || '').trim() : '';
          if (!text) { magEl.style.display = 'none'; return; }
          magEl.textContent = text.slice(0, 320);
          magEl.style.display = 'block';
          var top = ev.clientY + 24;
          if (top > window.innerHeight - 180) top = ev.clientY - 180;
          magEl.style.top = top + 'px';
        }, { passive: true });
      }
    }
    if (!state.features.textMagnifier && magEl) { magEl.remove(); magEl = null; }
  }

  /* ------------------------------------------------------------ UI css */
  function widgetCss() {
    var A = CFG.accent, AD = CFG.accentDark, Z = CFG.zIndex;
    return [
      '#' + ROOT_ID + '{all:initial;font-family:"Montserrat",-apple-system,"Segoe UI",Arial,sans-serif;}',
      '#' + ROOT_ID + ' *{box-sizing:border-box !important;font-family:inherit;letter-spacing:normal !important;word-spacing:normal !important;line-height:1.4;}',
      '@keyframes lenz-a11y-fadein{from{opacity:0;}to{opacity:1;}}',
      '@keyframes lenz-a11y-fadeout{from{opacity:1;}to{opacity:0;}}',
      '@keyframes lenz-a11y-rise{from{opacity:0;transform:translateY(6px) scale(.96);}to{opacity:1;transform:translateY(0) scale(1);}}',
      /* launcher: sutil — blanco, icono en color de marca, entra con fade */
      '#' + ROOT_ID + ' .lenz-a11y-btn{position:fixed !important;bottom:20px;z-index:' + Z + ' !important;width:46px;height:46px;border-radius:50%;border:1px solid rgba(11,83,148,.18);background:rgba(255,255,255,.94) !important;display:flex;align-items:center;justify-content:center;cursor:pointer !important;box-shadow:0 2px 10px rgba(10,30,50,.18);padding:0;opacity:.88;transition:opacity .2s ease,background-color .2s ease,box-shadow .2s ease,transform .2s ease;animation:lenz-a11y-fadein .45s ease both;}',
      '#' + ROOT_ID + ' .lenz-a11y-btn:hover{background:' + A + ' !important;opacity:1;transform:scale(1.05);box-shadow:0 4px 16px rgba(10,30,50,.3);}',
      '#' + ROOT_ID + ' .lenz-a11y-btn:focus-visible{outline:3px solid #ffbf00 !important;outline-offset:3px;opacity:1;}',
      '#' + ROOT_ID + ' .lenz-a11y-btn svg{width:26px;height:26px;fill:' + A + ';transition:fill .2s ease;}',
      '#' + ROOT_ID + ' .lenz-a11y-btn:hover svg,#' + ROOT_ID + ' .lenz-a11y-btn:focus-visible svg{fill:#fff;}',
      '#' + ROOT_ID + '[data-side="right"] .lenz-a11y-btn{right:20px;}',
      '#' + ROOT_ID + '[data-side="left"] .lenz-a11y-btn{left:20px;}',
      /* panel: fade in/out + leve slide, como las transiciones del sitio */
      '#' + ROOT_ID + ' .lenz-a11y-panel{position:fixed !important;top:0;bottom:0;z-index:' + (Z + 1) + ' !important;width:400px;max-width:96vw;background:#f7f9fc !important;color:#15202b !important;box-shadow:0 0 40px rgba(0,0,0,.45);display:flex;flex-direction:column;border:0;visibility:hidden;opacity:0;transition:opacity .25s ease,transform .25s ease,visibility 0s linear .25s;}',
      '#' + ROOT_ID + '[data-side="right"] .lenz-a11y-panel{right:0;transform:translateX(16px);}',
      '#' + ROOT_ID + '[data-side="left"] .lenz-a11y-panel{left:0;transform:translateX(-16px);}',
      '#' + ROOT_ID + ' .lenz-a11y-panel.open{visibility:visible;opacity:1;transform:translateX(0);transition:opacity .25s ease,transform .25s ease,visibility 0s;}',
      '#' + ROOT_ID + ' .lenz-a11y-head{background:' + A + ' !important;color:#fff !important;padding:12px 16px;display:flex;align-items:center;gap:8px;}',
      '#' + ROOT_ID + ' .lenz-a11y-head h2{font-size:19px;font-weight:700;margin:0;flex:1;color:#fff !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-iconbtn{background:rgba(255,255,255,.16) !important;border:1px solid rgba(255,255,255,.5);color:#fff !important;border-radius:8px;min-width:34px;height:34px;padding:0 8px;cursor:pointer !important;font-size:13px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;gap:4px;}',
      '#' + ROOT_ID + ' .lenz-a11y-iconbtn:hover{background:rgba(255,255,255,.3) !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-iconbtn:focus-visible{outline:3px solid #ffbf00 !important;outline-offset:2px;}',
      '#' + ROOT_ID + ' .lenz-a11y-iconbtn svg{width:18px;height:18px;fill:#fff;}',
      '#' + ROOT_ID + ' .lenz-a11y-lang{background:rgba(255,255,255,.16) !important;border:1px solid rgba(255,255,255,.5);color:#fff !important;border-radius:8px;height:34px;padding:0 6px;cursor:pointer !important;font-size:13px;font-weight:700;max-width:150px;}',
      '#' + ROOT_ID + ' .lenz-a11y-lang option{color:#15202b;background:#fff;}',
      '#' + ROOT_ID + ' .lenz-a11y-lang:focus-visible{outline:3px solid #ffbf00 !important;outline-offset:2px;}',
      '#' + ROOT_ID + ' .lenz-a11y-body{overflow-y:auto;padding:14px 16px 20px;flex:1;}',
      '#' + ROOT_ID + ' .lenz-a11y-section{margin:0 0 18px;}',
      '#' + ROOT_ID + ' .lenz-a11y-section h3{font-size:15px;font-weight:700;color:' + AD + ' !important;margin:0 0 3px;text-transform:uppercase;letter-spacing:.4px !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-hint{font-size:12px;color:#5a6b7b !important;margin:0 0 8px;}',
      '#' + ROOT_ID + ' .lenz-a11y-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;}',
      '#' + ROOT_ID + ' .lenz-a11y-grid.two{grid-template-columns:repeat(2,1fr);}',
      '#' + ROOT_ID + ' .lenz-a11y-card{background:#fff !important;border:2px solid #d4dde7;border-radius:10px;padding:10px 6px 8px;display:flex;flex-direction:column;align-items:center;gap:6px;cursor:pointer !important;min-height:76px;position:relative;color:#15202b !important;font-size:12.5px;font-weight:600;text-align:center;transition:background-color .18s ease,border-color .18s ease,color .18s ease,box-shadow .18s ease;}',
      '#' + ROOT_ID + ' .lenz-a11y-card:hover{border-color:' + A + ';background:#eef5ff !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-card:focus-visible{outline:3px solid #ffbf00 !important;outline-offset:2px;}',
      '#' + ROOT_ID + ' .lenz-a11y-card svg{width:26px;height:26px;fill:' + AD + ';}',
      '#' + ROOT_ID + ' .lenz-a11y-card[aria-pressed="true"]{border-color:' + A + ';background:' + A + ' !important;color:#fff !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-card[aria-pressed="true"] svg{fill:#fff;}',
      '#' + ROOT_ID + ' .lenz-a11y-card[aria-pressed="true"]::after{content:"✓";position:absolute;top:4px;right:7px;font-size:13px;font-weight:900;color:#fff;}',
      '#' + ROOT_ID + ' .lenz-a11y-lvl{display:flex;gap:3px;}',
      '#' + ROOT_ID + ' .lenz-a11y-lvl span{width:7px;height:7px;border-radius:50%;background:#c6d2de;}',
      '#' + ROOT_ID + ' .lenz-a11y-card[aria-pressed="true"] .lenz-a11y-lvl span{background:rgba(255,255,255,.45);}',
      '#' + ROOT_ID + ' .lenz-a11y-lvl span.on{background:' + AD + ';}',
      '#' + ROOT_ID + ' .lenz-a11y-card[aria-pressed="true"] .lenz-a11y-lvl span.on{background:#fff;}',
      '#' + ROOT_ID + ' .lenz-a11y-foot{border-top:1px solid #d4dde7;background:#fff !important;padding:10px 14px;display:flex;flex-wrap:wrap;gap:8px;justify-content:space-between;align-items:center;}',
      '#' + ROOT_ID + ' .lenz-a11y-foot button, #' + ROOT_ID + ' .lenz-a11y-foot a{background:none !important;border:none;color:' + AD + ' !important;font-size:13px;font-weight:700;cursor:pointer !important;text-decoration:underline;padding:4px;}',
      '#' + ROOT_ID + ' .lenz-a11y-foot button:focus-visible{outline:3px solid #ffbf00 !important;outline-offset:2px;}',
      /* modal (statement / structure): fade in/out */
      '#' + ROOT_ID + ' .lenz-a11y-modal{position:fixed;inset:0;z-index:' + (Z + 2) + ' !important;background:rgba(10,20,30,.55);display:flex;align-items:center;justify-content:center;padding:20px;animation:lenz-a11y-fadein .22s ease both;}',
      '#' + ROOT_ID + ' .lenz-a11y-modal.closing{animation:lenz-a11y-fadeout .18s ease both;}',
      '#' + ROOT_ID + ' .lenz-a11y-modal-card{background:#fff !important;color:#15202b !important;max-width:560px;width:100%;max-height:82vh;border-radius:12px;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 10px 50px rgba(0,0,0,.5);animation:lenz-a11y-rise .22s ease both;}',
      '#' + ROOT_ID + ' .lenz-a11y-modal-card header{background:' + A + ' !important;color:#fff !important;padding:12px 16px;display:flex;align-items:center;}',
      '#' + ROOT_ID + ' .lenz-a11y-modal-card header h2{font-size:17px;margin:0;flex:1;color:#fff !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-modal-body{padding:14px 18px;overflow-y:auto;font-size:14.5px;color:#20303f !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-tabs{display:flex;gap:6px;margin:0 0 10px;}',
      '#' + ROOT_ID + ' .lenz-a11y-tab{border:2px solid #d4dde7;background:#fff !important;border-radius:8px;padding:6px 12px;font-size:13px;font-weight:700;cursor:pointer !important;color:#15202b !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-tab[aria-selected="true"]{background:' + A + ' !important;color:#fff !important;border-color:' + A + ';}',
      '#' + ROOT_ID + ' .lenz-a11y-list{list-style:none;margin:0;padding:0;}',
      '#' + ROOT_ID + ' .lenz-a11y-list button{display:block;width:100%;text-align:left;background:#fff !important;border:0;border-bottom:1px solid #e4ebf2;padding:8px 6px;font-size:14px;cursor:pointer !important;color:#15202b !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-list button:hover{background:#eef5ff !important;}',
      '#' + ROOT_ID + ' .lenz-a11y-list .lvl{color:#7b8a99;font-size:11px;margin-right:6px;}',
      /* page helpers (outside root, need own ids) */
      '.lenz-a11y-guide{position:fixed !important;width:320px;height:14px;background:#ffd400;border:2px solid #202020;border-radius:8px;z-index:' + (Z - 2) + ' !important;pointer-events:none !important;box-shadow:0 2px 8px rgba(0,0,0,.4);}',
      '.lenz-a11y-mask{position:fixed !important;left:0;right:0;background:rgba(6,10,14,.62);z-index:' + (Z - 3) + ' !important;pointer-events:none !important;}',
      '.lenz-a11y-magnifier{position:fixed !important;left:50%;transform:translateX(-50%);max-width:720px;width:92vw;background:#101820 !important;color:#fff !important;font-size:26px !important;line-height:1.45 !important;padding:14px 20px;border-radius:12px;z-index:' + (Z - 1) + ' !important;pointer-events:none !important;box-shadow:0 6px 30px rgba(0,0,0,.5);display:none;font-family:Arial,sans-serif !important;}',
      'html.lenz-a11y-ttsmode body *:hover{cursor:context-menu;}',
      '.lenz-a11y-tts-hover{outline:3px dashed ' + A + ' !important;outline-offset:2px;}',
      '.lenz-a11y-flash{outline:4px solid #ffbf00 !important;outline-offset:3px;}',
      '@media (max-width:520px){#' + ROOT_ID + ' .lenz-a11y-panel{width:100vw;}#' + ROOT_ID + ' .lenz-a11y-grid{grid-template-columns:repeat(2,1fr);}}',
      /* respetar reduced-motion tambien en el propio widget */
      '@media (prefers-reduced-motion: reduce){#' + ROOT_ID + ' *,#' + ROOT_ID + '{animation:none !important;transition:none !important;}}'
    ].join('\n');
  }

  /* ------------------------------------------------------------- icons */
  function svg(inner) { return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + inner + '</svg>'; }
  function iconAccess() { return svg('<path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>'); }
  function iconFont() { return svg('<path d="M9.6 4h4.8l5.2 16h-3l-1.2-4H8.6l-1.2 4h-3L9.6 4zm.9 9.6h3.9L12.5 7l-2 6.6z"/>'); }
  function iconFontUp() { return svg('<path d="M7 4h4l4.5 14h-2.6l-1-3.4H6.1l-1 3.4H2.5L7 4zm.7 8.4h3.5L9.5 6.8l-1.8 5.6zM19 4h2v3h3v2h-3v3h-2V9h-3V7h3V4z"/>'); }
  function iconLetterSp() { return svg('<path d="M4 5h2v14H4V5zm14 0h2v14h-2V5zM9 8h6l-2.2 8H10.8L9 8zm2 2 .9 4h.2l.9-4h-2z"/>'); }
  function iconLineH() { return svg('<path d="M4 5h16v2H4V5zm0 6h16v2H4v-2zm0 6h16v2H4v-2z"/>'); }
  function iconLink() { return svg('<path d="M3.9 12a4.1 4.1 0 0 1 4.1-4.1h4v2h-4a2.1 2.1 0 0 0 0 4.2h4v2h-4A4.1 4.1 0 0 1 3.9 12zm8.1 1h-1v-2h1 5a1 1 0 0 0 0 .2 2.1 2.1 0 0 0-.9-4.1 4.1 4.1 0 0 1 0 8.2h-4v-2h4a2.1 2.1 0 0 0 0-4.2"/>' + '<path d="M8 11h8v2H8z"/>'); }
  function iconHeading() { return svg('<path d="M5 4h2v7h10V4h2v16h-2v-7H7v7H5V4z"/>'); }
  function iconMoon() { return svg('<path d="M12.3 2a9.9 9.9 0 1 0 9.7 12.4A8.1 8.1 0 0 1 12.3 2z"/>'); }
  function iconSun() { return svg('<path d="M12 6.5A5.5 5.5 0 1 1 6.5 12 5.5 5.5 0 0 1 12 6.5zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM1 11h3v2H1v-2zm19 0h3v2h-3v-2zM4 5.4 5.4 4l2.1 2.1-1.4 1.4L4 5.4zm12.5 12.5 1.4-1.4 2.1 2.1-1.4 1.4-2.1-2.1zM18.6 4 20 5.4l-2.1 2.1-1.4-1.4L18.6 4zM6.1 16.5l1.4 1.4L5.4 20 4 18.6l2.1-2.1z"/>'); }
  function iconMono() { return svg('<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 2v16a8 8 0 0 1 0-16z"/>'); }
  function iconDropLow() { return svg('<path d="M12 2s6.5 7.6 6.5 12.5a6.5 6.5 0 0 1-13 0C5.5 9.6 12 2 12 2zm0 3.2C10 8 7.5 11.7 7.5 14.5a4.5 4.5 0 0 0 9 0c0-1-.3-2.1-.8-3.2L12 5.2z"/>'); }
  function iconDropHigh() { return svg('<path d="M12 2s6.5 7.6 6.5 12.5a6.5 6.5 0 0 1-13 0C5.5 9.6 12 2 12 2z"/>'); }
  function iconCursor() { return svg('<path d="M6 2l12 11h-7l4 7-3 1.6L8.4 15 6 17V2z"/>'); }
  function iconGuide() { return svg('<path d="M3 10h18v4H3v-4zm2-6h14v2H5V4zm0 14h14v2H5v-2z"/>'); }
  function iconMask() { return svg('<path d="M2 3h20v5H2V3zm0 13h20v5H2v-5zm2-6h16v4H4v-4z" fill-opacity=".35"/><path d="M4 10h16v4H4z"/>'); }
  function iconPause() { return svg('<path d="M7 4h4v16H7V4zm6 0h4v16h-4V4z"/>'); }
  function iconImgOff() { return svg('<path d="M3 5h18v14H3V5zm2 2v10h14V7H5zm2 8 3-4 2 2.5L14 10l3 5H7z"/><path d="M2.5 2.5 21.5 21.5l-1.4 1.4L1.1 3.9z"/>'); }
  function iconKeyboard() { return svg('<path d="M2 6h20v12H2V6zm2 2v8h16V8H4zm2 1h2v2H6V9zm3 0h2v2H9V9zm3 0h2v2h-2V9zm3 0h2v2h-2V9zM6 12h2v2H6v-2zm3 0h8v2H9v-2z"/>'); }
  function iconZoom() { return svg('<path d="M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-1 2h2v3h3v2h-3v3H9v-3H6V9h3V6zm7.3 9.9 5.4 5.4-1.4 1.4-5.4-5.4 1.4-1.4z"/>'); }
  function iconSpeaker() { return svg('<path d="M3 9h4l6-5v16l-6-5H3V9zm13.5 3a3.5 3.5 0 0 0-2-3.2v6.4a3.5 3.5 0 0 0 2-3.2zm-2-7.7a8 8 0 0 1 0 15.4v-2.1a6 6 0 0 0 0-11.2V4.3z"/>'); }
  function iconMagText() { return svg('<path d="M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM7 8h6v1.6h-2.2V14H9.2V9.6H7V8zm9.3 7.9 5.4 5.4-1.4 1.4-5.4-5.4 1.4-1.4z"/>'); }
  function iconTree() { return svg('<path d="M4 4h7v4H4V4zm2 6h9v4H6v-4zm2 6h12v4H8v-4z"/>'); }
  function iconEyePlus() { return svg('<path d="M12 5c5 0 9 4.5 10 7-1 2.5-5 7-10 7S3 14.5 2 12c1-2.5 5-7 10-7zm0 2C8.5 7 5.6 9.9 4.2 12 5.6 14.1 8.5 17 12 17s6.4-2.9 7.8-5C18.4 9.9 15.5 7 12 7zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/>'); }
  function iconPalette() { return svg('<path d="M12 2a10 10 0 0 0 0 20c1.4 0 2-.9 2-2 0-.6-.2-1-.5-1.4-.3-.4-.5-.8-.5-1.3 0-1.1.9-2 2-2h2.3A4.7 4.7 0 0 0 22 10.6C22 5.8 17.5 2 12 2zm-5.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>'); }
  function iconShield() { return svg('<path d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3zm0 2.2 6 2.2V11c0 4-2.6 7.8-6 9-3.4-1.2-6-5-6-9V6.4l6-2.2z"/>'); }
  function iconTarget() { return svg('<path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>'); }
  function iconTypeDx() { return svg('<path d="M5 4h9a5 5 0 0 1 0 10H9v6H5V4zm4 3v4h4.8a2 2 0 0 0 0-4H9z"/>'); }
  function iconPerson() { return svg('<path d="M12 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 10c4.4 0 8 2.2 8 5v3H4v-3c0-2.8 3.6-5 8-5z"/>'); }
  function iconGlobe() { return svg('<path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2c-1.2 1.5-2.5 4.2-2.5 8s1.3 6.5 2.5 8c1.2-1.5 2.5-4.2 2.5-8S13.2 5.5 12 4zM4.6 9h3.2c.2-1.8.7-3.4 1.4-4.7A8 8 0 0 0 4.6 9zm10.2-4.7c.7 1.3 1.2 2.9 1.4 4.7h3.2a8 8 0 0 0-4.6-4.7zM4.6 15a8 8 0 0 0 4.6 4.7c-.7-1.3-1.2-2.9-1.4-4.7H4.6zm11.6 0c-.2 1.8-.7 3.4-1.4 4.7A8 8 0 0 0 19.4 15h-3.2z"/>'); }
  function iconSwap() { return svg('<path d="M8 5l-6 5 6 5v-3h8v-4H8V5zm8 14 6-5-6-5v3H8v4h8v3z"/>'); }
  function bigCursorData() {
    var s = '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24"><path d="M6 2l12 11h-7l4 7-3 1.6L8.4 15 6 17V2z" fill="#000" stroke="#fff" stroke-width="1.6"/></svg>';
    return 'data:image/svg+xml;base64,' + btoa(s);
  }

  /* --------------------------------------------------------------- UI */
  var root, panel, launcher, lastFocus = null, statusEl;

  function build() {
    root = el('div', { id: ROOT_ID, 'data-side': state.position });
    var uiStyle = el('style', { id: 'lenz-a11y-ui' });
    uiStyle.textContent = widgetCss();
    document.head.appendChild(uiStyle);
    fxStyle = el('style', { id: 'lenz-a11y-fx' });
    document.head.appendChild(fxStyle);

    if (!CFG.standby) {
      launcher = el('button', {
        'class': 'lenz-a11y-btn', type: 'button',
        'aria-label': t('openBtn'), title: t('openBtn'),
        'aria-haspopup': 'dialog', 'aria-expanded': 'false',
        onclick: togglePanel
      });
      launcher.innerHTML = iconAccess();
      root.appendChild(launcher);
    }

    panel = el('div', {
      'class': 'lenz-a11y-panel', role: 'dialog', 'aria-modal': 'false',
      'aria-label': t('title'), tabindex: '-1'
    });
    root.appendChild(panel);
    renderPanel();

    statusEl = el('div', { 'aria-live': 'polite', style: 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);' });
    root.appendChild(statusEl);

    document.body.appendChild(root);

    document.addEventListener('keydown', function (ev) {
      if (ev.altKey && (ev.key === '0' || ev.code === 'Digit0')) { ev.preventDefault(); togglePanel(); }
      if (ev.key === 'Escape' && panel.classList.contains('open')) { closePanel(); }
    });

    // clic/tap fuera del panel lo cierra (capture: gana a stopPropagation de la pagina)
    document.addEventListener('pointerdown', function (ev) {
      if (!panel.classList.contains('open')) return;
      if (root.contains(ev.target)) return;
      closePanel();
    }, true);

    // aperturas en modo standby (y utiles siempre):
    // enlaces a #accesibilidad (ej. menu del footer) o [data-lenz-a11y]
    document.addEventListener('click', function (ev) {
      var trigger = ev.target && ev.target.closest && ev.target.closest('a[href*="#accesibilidad"], [data-lenz-a11y]');
      if (!trigger || root.contains(trigger)) return;
      ev.preventDefault();
      openPanel();
    }, true);
    if (location.hash === '#accesibilidad') setTimeout(openPanel, 300);

    // API publica
    window.LenzA11y = { open: openPanel, close: closePanel, toggle: togglePanel };
  }

  function announce(msg) { if (statusEl) statusEl.textContent = msg; }

  function togglePanel() { panel.classList.contains('open') ? closePanel() : openPanel(); }
  function openPanel() {
    if (panel.classList.contains('open')) return;
    lastFocus = document.activeElement;
    panel.classList.add('open');
    if (launcher) launcher.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button');
    if (first) first.focus();
    panel.addEventListener('keydown', trapFocus);
  }
  function closePanel() {
    panel.classList.remove('open');
    if (launcher) launcher.setAttribute('aria-expanded', 'false');
    panel.removeEventListener('keydown', trapFocus);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
    else if (launcher) launcher.focus();
  }
  function trapFocus(ev) {
    if (ev.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('button, select, a[href], [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  }

  function renderPanel() {
    panel.innerHTML = '';
    panel.setAttribute('aria-label', t('title'));

    /* header */
    var head = el('div', { 'class': 'lenz-a11y-head' });
    var langBtn = el('select', {
      'class': 'lenz-a11y-lang', 'aria-label': t('language'), title: t('language'),
      onchange: function (ev) { state.lang = mapLang(ev.target.value); save(); renderPanel(); }
    });
    [['es', 'Español (Perú)'], ['qu', 'Runasimi (Quechua)'], ['en', 'English']].forEach(function (o) {
      var opt = el('option', { value: o[0], text: o[1] });
      if (state.lang === o[0]) opt.setAttribute('selected', 'selected');
      langBtn.appendChild(opt);
    });
    var sideBtn = el('button', { 'class': 'lenz-a11y-iconbtn', type: 'button', title: t('moveSide'), 'aria-label': t('moveSide'), onclick: function () { state.position = state.position === 'right' ? 'left' : 'right'; root.setAttribute('data-side', state.position); save(); } });
    sideBtn.innerHTML = iconSwap();
    var closeBtn = el('button', { 'class': 'lenz-a11y-iconbtn', type: 'button', 'aria-label': t('close'), title: t('close'), onclick: closePanel, text: '✕' });
    head.appendChild(el('h2', { text: t('title') }));
    head.appendChild(langBtn); head.appendChild(sideBtn); head.appendChild(closeBtn);
    panel.appendChild(head);

    /* body */
    var body = el('div', { 'class': 'lenz-a11y-body' });

    /* profiles */
    var secP = el('div', { 'class': 'lenz-a11y-section' });
    secP.appendChild(el('h3', { text: t('profiles') }));
    secP.appendChild(el('p', { 'class': 'lenz-a11y-hint', text: t('profilesHint') }));
    var gridP = el('div', { 'class': 'lenz-a11y-grid', role: 'group', 'aria-label': t('profiles') });
    Object.keys(PROFILES).forEach(function (pid) {
      var card = el('button', {
        'class': 'lenz-a11y-card', type: 'button',
        'aria-pressed': String(state.profile === pid),
        title: t('p_' + pid + '_d'),
        onclick: function () { applyProfile(pid); }
      });
      card.innerHTML = PROFILE_ICONS[pid] + '<span>' + t('p_' + pid) + '</span>';
      gridP.appendChild(card);
    });
    secP.appendChild(gridP);
    body.appendChild(secP);

    /* content section */
    body.appendChild(section(t('content'), [
      levelCard('fontSize', t('f_fontSize'), iconFontUp(), FONT_STEPS.length),
      toggleCard('readableFont', t('f_readableFont'), iconFont()),
      toggleCard('dyslexiaFont', t('f_dyslexiaFont'), iconTypeDx()),
      toggleCard('letterSpacing', t('f_letterSpacing'), iconLetterSp()),
      toggleCard('lineHeight', t('f_lineHeight'), iconLineH()),
      toggleCard('highlightLinks', t('f_highlightLinks'), iconLink()),
      toggleCard('highlightHeadings', t('f_highlightHeadings'), iconHeading()),
      levelCard('pageZoom', t('f_pageZoom'), iconZoom(), ZOOM_STEPS.length)
    ]));

    /* color section */
    body.appendChild(section(t('color'), [
      toggleCard('darkContrast', t('f_darkContrast'), iconMoon(), ['brightContrast', 'monochrome']),
      toggleCard('brightContrast', t('f_brightContrast'), iconSun(), ['darkContrast', 'monochrome']),
      toggleCard('monochrome', t('f_monochrome'), iconMono(), ['darkContrast', 'brightContrast', 'lowSat', 'highSat']),
      toggleCard('lowSat', t('f_lowSat'), iconDropLow(), ['highSat', 'monochrome']),
      toggleCard('highSat', t('f_highSat'), iconDropHigh(), ['lowSat', 'monochrome'])
    ]));

    /* navigation section */
    body.appendChild(section(t('nav'), [
      toggleCard('bigCursor', t('f_bigCursor'), iconCursor()),
      toggleCard('readingGuide', t('f_readingGuide'), iconGuide()),
      toggleCard('readingMask', t('f_readingMask'), iconMask()),
      toggleCard('stopAnimations', t('f_stopAnimations'), iconPause()),
      toggleCard('hideImages', t('f_hideImages'), iconImgOff()),
      toggleCard('focusMode', t('f_focusMode'), iconKeyboard())
    ]));

    /* tools section */
    var secT = el('div', { 'class': 'lenz-a11y-section' });
    secT.appendChild(el('h3', { text: t('tools') }));
    secT.appendChild(el('p', { 'class': 'lenz-a11y-hint', text: t('f_ttsHint') }));
    var gridT = el('div', { 'class': 'lenz-a11y-grid' });
    gridT.appendChild(toggleCard('tts', t('f_tts'), iconSpeaker()));
    gridT.appendChild(toggleCard('textMagnifier', t('f_textMagnifier'), iconMagText()));
    var structBtn = el('button', { 'class': 'lenz-a11y-card', type: 'button', 'aria-pressed': 'false', onclick: openStructure });
    structBtn.innerHTML = iconTree() + '<span>' + t('f_pageStructure') + '</span>';
    gridT.appendChild(structBtn);
    secT.appendChild(gridT);
    body.appendChild(secT);

    panel.appendChild(body);

    /* footer */
    var foot = el('div', { 'class': 'lenz-a11y-foot' });
    foot.appendChild(el('button', { type: 'button', text: t('reset'), onclick: resetAll }));
    foot.appendChild(el('button', { type: 'button', text: t('statement'), onclick: openStatement }));
    foot.appendChild(el('button', { type: 'button', text: t('hide'), onclick: hideWidget }));
    panel.appendChild(foot);
  }

  function section(title, cards) {
    var sec = el('div', { 'class': 'lenz-a11y-section' });
    sec.appendChild(el('h3', { text: title }));
    var grid = el('div', { 'class': 'lenz-a11y-grid', role: 'group', 'aria-label': title });
    cards.forEach(function (c) { grid.appendChild(c); });
    sec.appendChild(grid);
    return sec;
  }

  function toggleCard(fid, label, icon, excludes) {
    var card = el('button', {
      'class': 'lenz-a11y-card', type: 'button',
      'aria-pressed': String(!!state.features[fid]),
      onclick: function () {
        var on = !state.features[fid];
        state.features[fid] = on;
        if (on && excludes) excludes.forEach(function (x) { state.features[x] = false; });
        if (fid === 'tts' && on && !('speechSynthesis' in window)) {
          state.features.tts = false;
          announce(t('ttsUnsupported'));
        }
        state.profile = null;
        save(); syncEffects(); renderPanel();
        announce(label + (on ? ' ' + t('active') : ' ' + t('off')));
      }
    });
    card.innerHTML = icon + '<span>' + label + '</span>';
    return card;
  }

  function levelCard(fid, label, icon, steps) {
    var lvl = state.features[fid] || 0;
    var card = el('button', {
      'class': 'lenz-a11y-card', type: 'button',
      'aria-pressed': String(lvl > 0),
      'aria-label': label + (lvl > 0 ? ', ' + t('level') + ' ' + lvl + '/' + (steps - 1) : ''),
      onclick: function () {
        state.features[fid] = (state.features[fid] + 1) % steps;
        state.profile = null;
        save(); syncEffects(); renderPanel();
        var v = state.features[fid];
        announce(label + ': ' + (v === 0 ? t('off') : Math.round((fid === 'fontSize' ? FONT_STEPS : ZOOM_STEPS)[v] * 100) + '%'));
      }
    });
    var dots = '<span class="lenz-a11y-lvl">';
    for (var i = 1; i < steps; i++) dots += '<span class="' + (i <= lvl ? 'on' : '') + '"></span>';
    dots += '</span>';
    var pct = lvl > 0 ? ' ' + Math.round((fid === 'fontSize' ? FONT_STEPS : ZOOM_STEPS)[lvl] * 100) + '%' : '';
    card.innerHTML = icon + '<span>' + label + pct + '</span>' + dots;
    return card;
  }

  function applyProfile(pid) {
    var wasActive = state.profile === pid;
    // reset features first
    state.features = JSON.parse(JSON.stringify(DEFAULTS.features));
    if (!wasActive) {
      var preset = PROFILES[pid];
      Object.keys(preset).forEach(function (k) { state.features[k] = preset[k]; });
      state.profile = pid;
      announce(t('p_' + pid) + ' ' + t('active'));
    } else {
      state.profile = null;
      announce(t('off'));
    }
    save(); syncEffects(); renderPanel();
  }

  function resetAll() {
    state.features = JSON.parse(JSON.stringify(DEFAULTS.features));
    state.profile = null;
    save(); syncEffects(); renderPanel();
    announce(t('reset'));
  }

  function hideWidget() {
    closePanel();
    root.style.display = 'none';
    try { sessionStorage.setItem('lenz-a11y:hidden', '1'); } catch (e) {}
  }

  /* -------------------------------------------------- statement modal */
  function closeModal(overlay) {
    if (!overlay || overlay.__closing) return;
    overlay.__closing = true;
    overlay.classList.add('closing');
    var done = function () { overlay.remove(); };
    overlay.addEventListener('animationend', done, { once: true });
    setTimeout(done, 260); // fallback (reduced-motion desactiva la animacion)
  }
  function modal(titleText, bodyNode) {
    var overlay = el('div', { 'class': 'lenz-a11y-modal', onclick: function (ev) { if (ev.target === overlay) closeModal(overlay); } });
    var card = el('div', { 'class': 'lenz-a11y-modal-card', role: 'dialog', 'aria-modal': 'true', 'aria-label': titleText });
    var header = el('header');
    header.appendChild(el('h2', { text: titleText }));
    var x = el('button', { 'class': 'lenz-a11y-iconbtn', type: 'button', 'aria-label': t('close'), text: '✕', onclick: function () { closeModal(overlay); } });
    header.appendChild(x);
    card.appendChild(header);
    var b = el('div', { 'class': 'lenz-a11y-modal-body' });
    b.appendChild(bodyNode);
    card.appendChild(b);
    overlay.appendChild(card);
    overlay.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') { ev.stopPropagation(); closeModal(overlay); } });
    root.appendChild(overlay);
    x.focus();
    return overlay;
  }

  function openStatement() {
    var text = t('st_body').replace('{site}', CFG.siteName).replace('{email}', CFG.statementEmail);
    modal(t('st_title'), el('p', { text: text }));
  }

  /* -------------------------------------------------- structure modal */
  function openStructure() {
    var wrap = el('div');
    var tabs = el('div', { 'class': 'lenz-a11y-tabs', role: 'tablist' });
    var listWrap = el('div');
    wrap.appendChild(tabs); wrap.appendChild(listWrap);

    var datasets = {
      headings: function () {
        return Array.prototype.filter.call(document.querySelectorAll('h1,h2,h3,h4,h5,h6'), notInRoot).map(function (h) {
          return { label: h.textContent.trim().slice(0, 80) || '(vacío)', lvl: h.tagName, node: h };
        });
      },
      links: function () {
        return Array.prototype.filter.call(document.querySelectorAll('a[href]'), notInRoot).slice(0, 150).map(function (a) {
          return { label: (a.textContent.trim() || a.getAttribute('aria-label') || a.href).slice(0, 80), lvl: '', node: a };
        }).filter(function (i) { return i.label; });
      },
      landmarks: function () {
        return Array.prototype.filter.call(document.querySelectorAll('header,nav,main,footer,aside,form[role=search],[role=banner],[role=navigation],[role=main],[role=contentinfo],[role=search]'), notInRoot).map(function (n) {
          var name = n.getAttribute('aria-label') || n.getAttribute('role') || n.tagName.toLowerCase();
          return { label: name.slice(0, 60), lvl: n.tagName.toLowerCase(), node: n };
        });
      }
    };
    function notInRoot(n) { var r = document.getElementById(ROOT_ID); return !(r && r.contains(n)); }

    var current = 'headings';
    var overlay;
    function renderList() {
      listWrap.innerHTML = '';
      var items = datasets[current]();
      if (!items.length) { listWrap.appendChild(el('p', { text: t('s_empty') })); return; }
      var ul = el('ul', { 'class': 'lenz-a11y-list' });
      items.forEach(function (item) {
        var li = el('li');
        var btn = el('button', {
          type: 'button',
          onclick: function () {
            closeModal(overlay); closePanel();
            item.node.scrollIntoView({ block: 'center' });
            item.node.setAttribute('tabindex', '-1');
            item.node.focus({ preventScroll: true });
            flash(item.node);
          }
        });
        btn.innerHTML = (item.lvl ? '<span class="lvl">' + item.lvl + '</span>' : '') + escapeHtml(item.label);
        li.appendChild(btn); ul.appendChild(li);
      });
      listWrap.appendChild(ul);
    }
    [['headings', 's_headings'], ['links', 's_links'], ['landmarks', 's_landmarks']].forEach(function (def) {
      var tb = el('button', {
        'class': 'lenz-a11y-tab', type: 'button', role: 'tab',
        'aria-selected': String(current === def[0]),
        text: t(def[1]),
        onclick: function () {
          current = def[0];
          tabs.querySelectorAll('.lenz-a11y-tab').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          tb.setAttribute('aria-selected', 'true');
          renderList();
        }
      });
      tabs.appendChild(tb);
    });
    renderList();
    overlay = modal(t('s_title'), wrap);
  }

  function escapeHtml(s) { return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* --------------------------------------------------------------- boot */
  function boot() {
    try { if (sessionStorage.getItem('lenz-a11y:hidden') === '1') return; } catch (e) {}
    build();
    // better-than-EqualWeb: honor OS reduced-motion automatically on first visit
    try {
      if (!localStorage.getItem(LS_KEY) && window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
        state.features.stopAnimations = true;
        announce(t('autoReducedMotion'));
      }
    } catch (e) {}
    syncEffects();
    renderPanel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
